import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GrilleRechercheComponent } from '../../../../../val-ammon-composants/val-ammon-search-lib/src/public-api';
import { FileEFact, GenererEtTransmettrePieceRequest, GenererEtTransmettrePieceResultat } from '../../../../../val-ammon-services/val-services-efact-lib/src/lib/GenererEtTransmettrePiece';
import { RecupererEtEnregistrerPiecesResultat } from '../../../../../val-ammon-services/val-services-efact-lib/src/lib/RecupererEtEnregistrerPieces';
import { RecupererEtEnregistrerEncaissementsResultat } from '../../../../../val-ammon-services/val-services-efact-lib/src/lib/RecupererEtEnregistrerEncaissements';
import { TransmettreEncaissementsRequest, TransmettreEncaissementsResultat } from '../../../../../val-ammon-services/val-services-efact-lib/src/lib/TransmettreEncaissements';
import { SynchroniserEtatTransmissionEncaissementsResultat } from '../../../../../val-ammon-services/val-services-efact-lib/src/lib/SynchroniserEtatTransmissionEncaissements';
import { SynchroniserStatutsPiecesResultat } from '../../../../../val-ammon-services/val-services-efact-lib/src/lib/SynchroniserStatutsPieces';
import { ValApiResultat } from '../../../../../val-ammon-services/val-services-communs-lib/src/public-api';
import { EFactVenteService } from '../../../../../val-ammon-services/val-services-efact-lib/src/lib/val-services-efact-vente.service';
import { BarreMenusComponent, DonneesMenuItem } from '../../../../../val-ammon-composants/val-composants-lib/src/public-api';
import { GererHabilitationsMenuItems, PermissionsService } from '../../../../../val-ammon-permissions/val-permissions-lib/src/public-api';
import { VueFactureVenteFicheComponent } from './vue-facture-vente/vue-facture-vente-fiche/vue-facture-vente-fiche.component';
import { MajStatutPieceRequest } from '../../../../../val-ammon-services/val-services-efact-lib/src/lib/MajStatutPiece';
import { ActiverDesactiverPiecesVenteComponent } from './activer-desactiver-pieces-vente/activer-desactiver-pieces-vente.component';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { TranslocoLocaleService } from '@jsverse/transloco-locale';

//Composant vue facture vente recherche
@Component(
    {
        selector: 'val-vue-facture-vente-recherche',
        imports:
            [
                TranslocoModule,
                GrilleRechercheComponent,
                BarreMenusComponent,
                VueFactureVenteFicheComponent,
                ActiverDesactiverPiecesVenteComponent
            ],
        templateUrl: './vue-facture-vente-recherche.component.html',
        styleUrls: ['./vue-facture-vente-recherche.component.scss']
    })
export class VueFactureVenteRechercheComponent implements OnInit {
	//Création
	constructor(private permissionsService: PermissionsService, private eFactVenteService: EFactVenteService,
	            private translocoService: TranslocoService, private translocoLocaleService: TranslocoLocaleService,
	            route: ActivatedRoute) {
		//Onglet demandé par l'écran appelant, en paramètre matriciel de l'outlet page (SU #118071).
		//Lu dès la création : la grille charge ses onglets dans son propre ngOnInit.
		this.identifiantOngletInitial = route.snapshot.paramMap.get('onglet');

		this.menuItems = [];
		this.menuItemsSimpleSelection = [];
		this.menuItemsMultipleSelection = [];

		this.transmissionEnCours = false;
		this.afficherResumeTransmission = false;
		this.intervalId = null;

		this.resultatDerniereTransmission = null;
		this.dateMiseAJourResume = null;

		this.recuperationEnCours = false;
		this.afficherResumeRecuperation = false;
		this.dateMiseAJourResumeRecuperation = null;
		this.resultatDerniereRecuperation = null;
		this.intervalIdRecuperation = null;

		this.synchronisationStatutsEnCours = false;
		this.afficherResumeSynchronisationStatuts = false;
		this.resultatDerniereSynchronisationStatuts = null;
		this.dateMiseAJourResumeSynchronisationStatuts = null;
		this.intervalIdSynchronisationStatuts = null;

		this.importEncaissementsEnCours = false;
		this.afficherResumeImportEncaissements = false;
		this.resultatDernierImportEncaissements = null;
		this.dateMiseAJourResumeImportEncaissements = null;
		this.intervalIdImportEncaissements = null;

		this.transmissionEncaissementsEnCours = false;
		this.afficherResumeTransmissionEncaissements = false;
		this.resultatDerniereTransmissionEncaissements = null;
		this.dateMiseAJourResumeTransmissionEncaissements = null;
		this.intervalIdTransmissionEncaissements = null;

		this.synchronisationEtatEncaissementsEnCours = false;
		this.afficherResumeSynchronisationEtatEncaissements = false;
		this.resultatDerniereSynchronisationEtatEncaissements = null;
		this.dateMiseAJourResumeSynchronisationEtatEncaissements = null;
		this.intervalIdSynchronisationEtatEncaissements = null;
	}

    //Indique si une transmission est en cours
    private transmissionEnCours: boolean;

    //Indique si une récupération est en cours
    private recuperationEnCours: boolean;

		//Indique si une synchronisation des statuts est en cours
	private synchronisationStatutsEnCours: boolean;

	//Indique si le résumé de synchronisation des statuts doit être affiché
	public afficherResumeSynchronisationStatuts: boolean;

	//Contient le résultat de la dernière synchronisation des statuts effectuée
	public resultatDerniereSynchronisationStatuts: SynchroniserStatutsPiecesResultat | null;

	//Date de mise à jour du résumé de synchronisation des statuts (pour afficher le temps écoulé)
	public dateMiseAJourResumeSynchronisationStatuts: Date | null;

	//Identifiant de l'intervalle de mise à jour du temps écoulé (synchronisation statuts)
	private intervalIdSynchronisationStatuts: ReturnType<typeof setInterval> | null;

	//Indique si le résumé de transmission doit être affiché
	public afficherResumeTransmission: boolean;

    //Contient le résultat de la dernière transmission effectuée
    public resultatDerniereTransmission: GenererEtTransmettrePieceResultat | null;

    //Date de mise à jour du résumé de transmission (pour afficher le temps écoulé)
    public dateMiseAJourResume: Date | null;

    //Identifiant de l'intervalle de mise à jour du temps écoulé (transmission)
    private intervalId: ReturnType<typeof setInterval> | null;

    //Indique si le résumé de récupération doit être affiché
    public afficherResumeRecuperation: boolean;

    //Contient le résultat de la dernière récupération effectuée
    public resultatDerniereRecuperation: RecupererEtEnregistrerPiecesResultat | null;

    //Date de mise à jour du résumé de récupération (pour afficher le temps écoulé)
    public dateMiseAJourResumeRecuperation: Date | null;

    //Identifiant de l'intervalle de mise à jour du temps écoulé (récupération)
    private intervalIdRecuperation: ReturnType<typeof setInterval> | null;

    //Indique si un import d'encaissements est en cours
    private importEncaissementsEnCours: boolean;

    //Indique si le résumé d'import d'encaissements doit être affiché
    public afficherResumeImportEncaissements: boolean;

    //Contient le résultat du dernier import d'encaissements effectué
    public resultatDernierImportEncaissements: RecupererEtEnregistrerEncaissementsResultat | null;

    //Date de mise à jour du résumé d'import d'encaissements (pour afficher le temps écoulé)
    public dateMiseAJourResumeImportEncaissements: Date | null;

    //Identifiant de l'intervalle de mise à jour du temps écoulé (import encaissements)
    private intervalIdImportEncaissements: ReturnType<typeof setInterval> | null;

    //Indique si une transmission d'encaissements est en cours
    private transmissionEncaissementsEnCours: boolean;

    //Indique si le résumé de transmission d'encaissements doit être affiché
    public afficherResumeTransmissionEncaissements: boolean;

    //Contient le résultat de la dernière transmission d'encaissements effectuée
    public resultatDerniereTransmissionEncaissements: TransmettreEncaissementsResultat | null;

    //Date de mise à jour du résumé de transmission d'encaissements (pour afficher le temps écoulé)
    public dateMiseAJourResumeTransmissionEncaissements: Date | null;

    //Identifiant de l'intervalle de mise à jour du temps écoulé (transmission encaissements)
    private intervalIdTransmissionEncaissements: ReturnType<typeof setInterval> | null;

    //Indique si une synchronisation des états d'encaissement est en cours
    private synchronisationEtatEncaissementsEnCours: boolean;

    //Indique si le résumé de synchronisation des états d'encaissement doit être affiché
    public afficherResumeSynchronisationEtatEncaissements: boolean;

    //Contient le résultat de la dernière synchronisation des états d'encaissement
    public resultatDerniereSynchronisationEtatEncaissements: SynchroniserEtatTransmissionEncaissementsResultat | null;

    //Date de mise à jour du résumé de synchronisation des états d'encaissement (pour afficher le temps écoulé)
    public dateMiseAJourResumeSynchronisationEtatEncaissements: Date | null;

    //Identifiant de l'intervalle de mise à jour du temps écoulé (synchronisation états encaissements)
    private intervalIdSynchronisationEtatEncaissements: ReturnType<typeof setInterval> | null;

    public menuItems: DonneesMenuItem[];

    //Identifiant de l'onglet à ouvrir, reçu en paramètre de route (null = onglet par défaut)
    public identifiantOngletInitial: string | null;

    //Menu items actif sur simple sélection
    public menuItemsSimpleSelection: DonneesMenuItem[];

    //Menu items actif sur multiple sélection
    public menuItemsMultipleSelection: DonneesMenuItem[];

    //Grille de recherche
    @ViewChild("grilleRecherche")
    public grilleRecherche!: GrilleRechercheComponent;

    //Vue Vente
    @ViewChild("factureVenteFiche")
	public factureVenteFiche!: VueFactureVenteFicheComponent;

    //Traitement d'activation / désactivation des pièces de vente (SU #118690)
    @ViewChild("activerDesactiverPiecesVente")
    public activerDesactiverPiecesVente!: ActiverDesactiverPiecesVenteComponent;

    //Initialise le composant
    public async ngOnInit(): Promise<void> {
        await this.CreerMenuItems();
        this.InitialiserMenuItems();
    }

    //Crée les menu items
    private async CreerMenuItems(): Promise<void> {
        let menuItems: DonneesMenuItem[];
        let gererHabilitationsMenuItems: GererHabilitationsMenuItems;

        const menuOuvrir: DonneesMenuItem = {dico: "75DE5D8C-0E4E-4956-AB8F-C79AE0AA09D5", iconeClass: "fas fa-external-link", action: this.Ouvrir.bind (this)};
		const menuItemRecuperer: DonneesMenuItem = { dico: "54FC1AEB-4AA4-4469-96BD-E3BBDDA34641", iconeClass: "fas fa-cloud-download-alt", action: this.RecupererPieces.bind(this) };
		const menuItemTransmettre: DonneesMenuItem = { dico: "B2CCC421-C94F-4D65-9BBF-E54AAA36F146", iconeClass: "fas fa-paper-plane", action: this.TransmettrePieces.bind(this) };
		const menuItemSynchroniserStatuts: DonneesMenuItem = { dico: "AFBDB98D-4D22-417D-9254-E0AFCE7F4E29", iconeClass: "fas fa-sync-alt", action: this.SynchroniserStatuts.bind(this) };

		const menuItemImporterEncaissements: DonneesMenuItem = { dico: "BA95A9DE-410F-4C5F-8481-027A99DC16A3", iconeClass: "fas fa-cloud-download-alt", action: this.ImporterEncaissements.bind(this) };
		const menuItemTransmettreEncaissements: DonneesMenuItem = { dico: "420EE28C-8EAC-4E0E-8915-E506D8DA754D", iconeClass: "fas fa-paper-plane", action: this.TransmettreEncaissements.bind(this) };
		const menuItemSynchroniserEtatEncaissements: DonneesMenuItem = { dico: "6D6B7A47-A752-483E-8250-564CFF831684", iconeClass: "fas fa-sync-alt", action: this.SynchroniserEtatEncaissements.bind(this) };
		const menuEncaissements: DonneesMenuItem = { dico: "76F3C074-935D-4584-BFFE-5CE5F11796AD", iconeClass: "fas fa-wallet", items: [menuItemImporterEncaissements, menuItemTransmettreEncaissements, menuItemSynchroniserEtatEncaissements] };

		//Bascule de l'état d'activation des pièces sélectionnées (SU #118690). Dico dédié : neutraliser
		//une pièce la retire du périmètre des traitements de masse, un geste habilitable pour lui-même.
		const menuItemActiverDesactiver: DonneesMenuItem = { dico: "B9B387CA-7D49-45D2-B770-9821D80F3DFF", iconeClass: "fas fa-ban", action: this.ActiverDesactiverPiecesVente.bind(this) };

		menuItems = [menuOuvrir, menuItemRecuperer, menuItemTransmettre, menuItemSynchroniserStatuts, menuEncaissements, menuItemActiverDesactiver];

        this.menuItemsSimpleSelection.push(menuOuvrir);

        //L'activation porte sur la sélection : sans ligne cochée, elle n'a rien à basculer. C'est la
        //première entrée de menuItemsMultipleSelection, jusqu'ici déclaré et jamais alimenté.
        this.menuItemsMultipleSelection.push(menuItemActiverDesactiver);

        gererHabilitationsMenuItems = new GererHabilitationsMenuItems(menuItems, this.permissionsService);

        this.menuItems = await gererHabilitationsMenuItems.Executer();
    }  
    
    //Initialise le menu
    private InitialiserMenuItems () : void 
    {
      for (const menuItem of this.menuItemsSimpleSelection)
        menuItem.disabled = true;
  
      for (const menuItem of this.menuItemsMultipleSelection)
        menuItem.disabled = true;
    } 
    
    //Traite le changement de sélection
    public SelectionChange () : void 
    {
      let simpleActif: boolean;
      let multipleActif: boolean;

      if (this.grilleRecherche.identifiantsSelectionnes.length > 0)
      {
        simpleActif = this.grilleRecherche.identifiantsSelectionnes.length === 1;
        multipleActif = true;
      }
      else
      {
        simpleActif = this.grilleRecherche.identifiantFocus !== null;
        multipleActif = this.grilleRecherche.identifiantFocus !== null;
      }

      for (const menuItem of this.menuItemsSimpleSelection)
        menuItem.disabled = !simpleActif;

      for (const menuItem of this.menuItemsMultipleSelection)
        menuItem.disabled = !multipleActif;
    }

    //Exécute les actions sur un double click
    public ExecuterActionsSurDoubleClick () : void 
    {
      this.Ouvrir ();
    }

    //Ouvre la fiche de consultation de la facture de vente
    private Ouvrir(): void {
      const idVente = this.RetournerIdentifiantSelectionne();
      if (idVente)
        this.factureVenteFiche.Ouvrir(idVente);
    }

    //Retourne l’identifiant du client sélectionné
    //  Retourne
    //    Identifiant du client sélectionné
    private RetournerIdentifiantSelectionne () : string | null
    {
      let identifiant: string | null = null;
  
      if (this.grilleRecherche.identifiantFocus)
        identifiant = this.grilleRecherche.identifiantFocus;
      else if(this.grilleRecherche.identifiantsSelectionnes.length > 0)
        identifiant = this.grilleRecherche.identifiantsSelectionnes[0];

      return identifiant;
    }

    //Retourne les identifiants des pièces sélectionnées
    //  Les lignes cochées priment ; à défaut, la ligne au focus vaut sélection d'une seule pièce —
    //  même convention que sur la grille des achats.
    //  Retourne
    //    Identifiants des pièces sélectionnées
    private RetournerIdentifiantsSelectionnees () : string[]
    {
      let identifiantsPieces: string[];

      if (this.grilleRecherche.identifiantsSelectionnes.length > 0)
        identifiantsPieces = this.grilleRecherche.identifiantsSelectionnes;
      else if (this.grilleRecherche.identifiantFocus)
        identifiantsPieces = [this.grilleRecherche.identifiantFocus];
      else
        identifiantsPieces = [];

      return identifiantsPieces;
    }

    //Active ou désactive les pièces de vente sélectionnées (SU #118690)
    //  Neutralise des lignes du SAS sans les supprimer — le cas d'usage est une facture transmise à
    //  tort. Les onglets de consultation ne filtrent pas EST_DESACTIVE sur l'onglet Défaut : une
    //  pièce désactivée reste dans la grille, donc réactivable par le même traitement.
    public async ActiverDesactiverPiecesVente () : Promise<void>
    {
      let modifiee: boolean;

      modifiee = await this.activerDesactiverPiecesVente.Executer (this.RetournerIdentifiantsSelectionnees ());

      //La colonne « Active » de la grille est peuplée par la recherche : sans relance, elle reste sur
      //l'état d'avant le traitement sous les yeux de l'utilisateur qui vient de le lancer.
      if (modifiee)
        await this.RafraichirGrilleApresTraitement ();
    }

    //Relance la recherche pour refléter l'état posé par le traitement
    private async RafraichirGrilleApresTraitement () : Promise<void>
    {
      try
      {
        //ExecuterRecherche est un chargeur paginé qui concatène la page reçue aux données déjà
        //affichées : sans remise à zéro préalable, il redemande la page courante et la duplique.
        this.grilleRecherche.ReinitaliserRecherche ();

        await this.grilleRecherche.ExecuterRecherche ();
      }
      catch (erreur)
      {
        //Le traitement a abouti : l'échec du seul rafraîchissement d'affichage ne doit pas être
        //présenté comme un échec du traitement.
        console.log (erreur);
      }
    }

    //Récupère et enregistre les pièces électroniques de vente depuis la source externe
    private async RecupererPieces(itemMenu?: DonneesMenuItem): Promise<void> {
        if (this.recuperationEnCours) {
            return;
        }

        let resultatRecuperation: ValApiResultat<RecupererEtEnregistrerPiecesResultat>;
        const itemRecuperation = itemMenu;

        this.MasquerResumeRecuperation();
        this.recuperationEnCours = true;
        if (itemRecuperation) {
            itemRecuperation.disabled = true;
        }

        this.grilleRecherche.operationEnCours = true;

        try {
            resultatRecuperation = await this.eFactVenteService.RecupererPieces();
            if (resultatRecuperation.status == "success") {
                this.AfficherResumeRecuperation(resultatRecuperation.resultat);
                this.grilleRecherche.ReinitaliserRecherche();
                await this.grilleRecherche.ExecuterRecherche();
            }
            else {
                if (resultatRecuperation.message) {
                    console.log(resultatRecuperation.message);
                    alert(this.TexteErreur('vente.recherche.erreur-recuperation-pieces', resultatRecuperation.message));
                }
                else if (resultatRecuperation.messages) {
                    console.log(resultatRecuperation.messages);
                    alert(this.TexteErreurs('vente.recherche.erreur-recuperation-pieces', resultatRecuperation.messages));
                }
            }
        }
        catch (error_) {
			const message = error_ != null && typeof (error_ as { message?: unknown }).message === 'string' ? (error_ as { message: string }).message : JSON.stringify(error_);
            alert(this.TexteErreur('vente.recherche.erreur-recuperation-pieces', message));
        }
        finally {
            this.grilleRecherche.operationEnCours = false;
            this.recuperationEnCours = false;

            if (itemRecuperation) {
                itemRecuperation.disabled = false;
            }
        }
    }

    //Importe les encaissements depuis la source externe
    private async ImporterEncaissements(itemMenu?: DonneesMenuItem): Promise<void> {
        if (this.importEncaissementsEnCours) {
            return;
        }

        let resultatImport: ValApiResultat<RecupererEtEnregistrerEncaissementsResultat>;
        const itemImport = itemMenu;

        this.MasquerResumeImportEncaissements();
        this.importEncaissementsEnCours = true;
        if (itemImport) {
            itemImport.disabled = true;
        }

        this.grilleRecherche.operationEnCours = true;

        try {
            resultatImport = await this.eFactVenteService.ImporterEncaissements();
			if (resultatImport.status == "success") {
				this.AfficherResumeImportEncaissements(resultatImport.resultat);
				this.grilleRecherche.ReinitaliserRecherche();
				await this.grilleRecherche.ExecuterRecherche();
			}
			else if (resultatImport.message) {
				console.log(resultatImport.message);
				alert(this.TexteErreur('vente.recherche.erreur-import-encaissements', resultatImport.message));
			}
			else if (resultatImport.messages) {
                console.log(resultatImport.messages);
                alert(this.TexteErreurs('vente.recherche.erreur-import-encaissements', resultatImport.messages));
            }
        }
        catch (error_) {
            const message = error_ != null && typeof (error_ as { message?: unknown }).message === 'string' ? (error_ as { message: string }).message : JSON.stringify(error_);
            alert(this.TexteErreur('vente.recherche.erreur-import-encaissements', message));
        }
        finally {
            this.grilleRecherche.operationEnCours = false;
            this.importEncaissementsEnCours = false;

            if (itemImport) {
                itemImport.disabled = false;
            }

            await this.eFactVenteService.AccuserReceptionEncaissements();
        }
    }

    //Transmet les encaissements des pièces de vente à la PA
    private async TransmettreEncaissements(itemMenu?: DonneesMenuItem): Promise<void> {
        if (this.transmissionEncaissementsEnCours) {
            return;
        }

        let resultatTransmission: ValApiResultat<TransmettreEncaissementsResultat>;
        const itemTransmission = itemMenu;

        this.MasquerResumeTransmissionEncaissements();
        this.transmissionEncaissementsEnCours = true;
        if (itemTransmission) {
            itemTransmission.disabled = true;
        }

        this.grilleRecherche.operationEnCours = true;

        try {
            const request = new TransmettreEncaissementsRequest();
            request.pieceIds = this.grilleRecherche.identifiantsSelectionnes;

            resultatTransmission = await this.eFactVenteService.TransmettreEncaissements(request);
			if (resultatTransmission.status == "success") {
				this.AfficherResumeTransmissionEncaissements(resultatTransmission.resultat);
				this.grilleRecherche.ReinitaliserRecherche();
				await this.grilleRecherche.ExecuterRecherche();
			}
			else if (resultatTransmission.message) {
				console.log(resultatTransmission.message);
				alert(this.TexteErreur('vente.recherche.erreur-transmission-encaissements', resultatTransmission.message));
			}
			else {
				console.log(resultatTransmission.messages);
				alert(this.TexteErreurs('vente.recherche.erreur-transmission-encaissements', resultatTransmission.messages));
			}
        }
        catch (error_) {
            const message = error_ != null && typeof (error_ as { message?: unknown }).message === 'string' ? (error_ as { message: string }).message : JSON.stringify(error_);
            alert(this.TexteErreur('vente.recherche.erreur-transmission-encaissements', message));
        }
        finally {
            this.grilleRecherche.operationEnCours = false;
            this.transmissionEncaissementsEnCours = false;

            if (itemTransmission) {
                itemTransmission.disabled = false;
            }
        }
    }

    //Transmet les pièces de vente
    private async TransmettrePieces(itemMenu?: DonneesMenuItem): Promise<void> {
        if (this.transmissionEnCours) {
            return;
        }

        let resultatTransmission: ValApiResultat<GenererEtTransmettrePieceResultat>;
        const itemTransmission = itemMenu;

        this.MasquerResumeTransmission();
        this.transmissionEnCours = true;
        if (itemTransmission) {
            itemTransmission.disabled = true;
        }

        this.grilleRecherche.operationEnCours = true;		

        try {
            let genererEtTransmettrePieceRequest = new GenererEtTransmettrePieceRequest();
            genererEtTransmettrePieceRequest.pieceIds = this.grilleRecherche.identifiantsSelectionnes;

            resultatTransmission = await this.eFactVenteService.TransmettrePieces(genererEtTransmettrePieceRequest);
            if (resultatTransmission.status == "success") {
                this.AfficherResumeTransmission(resultatTransmission.resultat);
     
                this.grilleRecherche.ReinitaliserRecherche();
                await this.grilleRecherche.ExecuterRecherche();
            }
            else {

                if (resultatTransmission.message) {
                    console.log(resultatTransmission.message);
                    alert(this.TexteErreur('vente.recherche.erreur-transmission-pieces', resultatTransmission.message));
                }
                else if (resultatTransmission.messages) {
                    console.log(resultatTransmission.messages);
                    alert(this.TexteErreurs('vente.recherche.erreur-transmission-pieces', resultatTransmission.messages));
                }
            }
        }
        catch (error_) {
            //Un 409 (transmission déjà en cours pour le client) porte son explication dans le corps de la réponse
            const corps = (error_ as { error?: { message?: unknown } } | null)?.error;
            const message = typeof corps?.message === 'string' && corps.message !== ''
                ? corps.message
                : error_ != null && typeof (error_ as { message?: unknown }).message === 'string' ? (error_ as { message: string }).message : JSON.stringify(error_);
            alert(this.TexteErreur('vente.recherche.erreur-transmission-pieces', message));
        }
        finally {
            this.grilleRecherche.operationEnCours = false;
            this.transmissionEnCours = false;

            if (itemTransmission) {
                itemTransmission.disabled = false;
            }

            let majStatutPieceRequest = new MajStatutPieceRequest();
            majStatutPieceRequest.pieceIds = this.grilleRecherche.identifiantsSelectionnes;

			await this.eFactVenteService.SynchroniserStatutActuelPieces(majStatutPieceRequest);
        }
    }

	private async SynchroniserStatuts(itemMenu?: DonneesMenuItem): Promise<void> {
		if (this.synchronisationStatutsEnCours) {
			return;
		}

		this.MasquerResumeSynchronisationStatuts();

		let resultatSynchronisation: ValApiResultat<SynchroniserStatutsPiecesResultat>;
		const itemSynchronisation = itemMenu;

		this.synchronisationStatutsEnCours = true;
		if (itemSynchronisation) {
			itemSynchronisation.disabled = true;
		}

		this.grilleRecherche.operationEnCours = true;

		try {
			resultatSynchronisation = await this.eFactVenteService.SynchroniserStatutsPieces();
			if (resultatSynchronisation.status == "success") {
				this.grilleRecherche.ReinitaliserRecherche();
				await this.grilleRecherche.ExecuterRecherche();
				this.AfficherResumeSynchronisationStatuts(resultatSynchronisation.resultat);
			}
			else {
				if (resultatSynchronisation.message) {
					console.log(resultatSynchronisation.message);
					alert(this.TexteErreur('vente.recherche.erreur-synchronisation-statuts', resultatSynchronisation.message));
				}
				else if (resultatSynchronisation.messages) {
					console.log(resultatSynchronisation.messages);
					alert(this.TexteErreurs('vente.recherche.erreur-synchronisation-statuts', resultatSynchronisation.messages));
				}
			}
		}
		catch (error_) {
			const message = error_ != null && typeof (error_ as { message?: unknown }).message === 'string' ? (error_ as { message: string }).message : JSON.stringify(error_);
			alert(this.TexteErreur('vente.recherche.erreur-synchronisation-statuts', message));
		}
		finally {
			this.grilleRecherche.operationEnCours = false;
			this.synchronisationStatutsEnCours = false;

			if (itemSynchronisation) {
				itemSynchronisation.disabled = false;
			}

            let majStatutPieceRequest = new MajStatutPieceRequest();
            majStatutPieceRequest.pieceIds = [];

            await this.eFactVenteService.SynchroniserStatutActuelPieces(majStatutPieceRequest);
		}
	}

	//Synchronise les états de transmission des encaissements avec la PA
	private async SynchroniserEtatEncaissements(itemMenu?: DonneesMenuItem): Promise<void> {
		if (this.synchronisationEtatEncaissementsEnCours) {
			return;
		}

		let resultatSynchronisation: ValApiResultat<SynchroniserEtatTransmissionEncaissementsResultat>;
		const itemSynchronisation = itemMenu;

		this.MasquerResumeSynchronisationEtatEncaissements();
		this.synchronisationEtatEncaissementsEnCours = true;
		if (itemSynchronisation) {
			itemSynchronisation.disabled = true;
		}

		this.grilleRecherche.operationEnCours = true;

		try {
			resultatSynchronisation = await this.eFactVenteService.SynchroniserEtatTransmissionEncaissements();
			if (resultatSynchronisation.status == "success") {
				this.AfficherResumeSynchronisationEtatEncaissements(resultatSynchronisation.resultat);
				this.grilleRecherche.ReinitaliserRecherche();
				await this.grilleRecherche.ExecuterRecherche();
			}
			else if (resultatSynchronisation.message) {
				console.log(resultatSynchronisation.message);
				alert(this.TexteErreur('vente.recherche.erreur-synchronisation-etat-encaissements', resultatSynchronisation.message));
			}
			else if (resultatSynchronisation.messages) {
				console.log(resultatSynchronisation.messages);
				alert(this.TexteErreurs('vente.recherche.erreur-synchronisation-etat-encaissements', resultatSynchronisation.messages));
			}
		}
		catch (error_) {
			const message = error_ != null && typeof (error_ as { message?: unknown }).message === 'string' ? (error_ as { message: string }).message : JSON.stringify(error_);
			alert(this.TexteErreur('vente.recherche.erreur-synchronisation-etat-encaissements', message));
		}
		finally {
			this.grilleRecherche.operationEnCours = false;
			this.synchronisationEtatEncaissementsEnCours = false;

			if (itemSynchronisation) {
				itemSynchronisation.disabled = false;
			}
		}
	}

	//Affiche le résumé de la dernière synchronisation des états d'encaissement
	public AfficherResumeSynchronisationEtatEncaissements(resultat?: SynchroniserEtatTransmissionEncaissementsResultat | null): void {
		this.resultatDerniereSynchronisationEtatEncaissements = resultat ?? new SynchroniserEtatTransmissionEncaissementsResultat();
		this.dateMiseAJourResumeSynchronisationEtatEncaissements = new Date();
		this.afficherResumeSynchronisationEtatEncaissements = true;

		if (this.intervalIdSynchronisationEtatEncaissements) {
			clearInterval(this.intervalIdSynchronisationEtatEncaissements);
		}
		this.intervalIdSynchronisationEtatEncaissements = setInterval(() => {
			this.dateMiseAJourResumeSynchronisationEtatEncaissements = this.dateMiseAJourResumeSynchronisationEtatEncaissements;
		}, 60000);
	}

	//Masque le résumé de la dernière synchronisation des états d'encaissement
	public MasquerResumeSynchronisationEtatEncaissements(): void {
		this.afficherResumeSynchronisationEtatEncaissements = false;
		this.resultatDerniereSynchronisationEtatEncaissements = null;
		this.dateMiseAJourResumeSynchronisationEtatEncaissements = null;

		if (this.intervalIdSynchronisationEtatEncaissements) {
			clearInterval(this.intervalIdSynchronisationEtatEncaissements);
			this.intervalIdSynchronisationEtatEncaissements = null;
		}
	}

	//Retourne le nombre d'encaissements transmis avec succès
	public ObtenirNombreEncaissementsEtatSucces(): number {
		return this.resultatDerniereSynchronisationEtatEncaissements?.nbEncaissementsEnSucces ?? 0;
	}

	//Retourne le nombre d'encaissements en attente de traitement par la PA
	public ObtenirNombreEncaissementsEtatNonTraites(): number {
		return this.resultatDerniereSynchronisationEtatEncaissements?.nbEncaissementsNonTraites ?? 0;
	}

	//Retourne le nombre d'encaissements non synchronisés car le paramétrage PA est introuvable
	public ObtenirNombreEncaissementsEtatParametragesIntrouvables(): number {
		return this.resultatDerniereSynchronisationEtatEncaissements?.nbEncaissementsParametragesIntrouvables ?? 0;
	}

	//Retourne le nombre d'encaissements en erreur de transmission
	public ObtenirNombreEncaissementsEtatEnErreur(): number {
		return this.resultatDerniereSynchronisationEtatEncaissements?.nbEncaissementsEnErreur ?? 0;
	}

	//Retourne le nombre d'encaissements non synchronisés à cause d'une erreur technique
	public ObtenirNombreEncaissementsEtatErreurTechnique(): number {
		return Object.keys(this.resultatDerniereSynchronisationEtatEncaissements?.encaissementsSynchroErreurTechnique ?? {}).length;
	}

	//Affiche le résumé de la dernière transmission
	public AfficherResumeTransmission(resultat?: GenererEtTransmettrePieceResultat | null): void {
		this.resultatDerniereTransmission = resultat ?? new GenererEtTransmettrePieceResultat();
		this.dateMiseAJourResume = new Date();
		this.afficherResumeTransmission = true;

        // Démarrer l'intervalle de mise à jour du temps écoulé
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
        this.intervalId = setInterval(() => {
            // Forcer la détection de changement en changeant une référence
            this.dateMiseAJourResume = this.dateMiseAJourResume;
        }, 60000);
    }

    //Masque le résumé de la dernière transmission
    public MasquerResumeTransmission(): void {
        this.afficherResumeTransmission = false;
        this.resultatDerniereTransmission = null;
        this.dateMiseAJourResume = null;

        // Arrêter l'intervalle de mise à jour
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }

    //Retourne le nombre de pièces transmises
    public ObtenirNombrePiecesTransmises(): number {
        return this.resultatDerniereTransmission?.piecesTransmises?.length ?? 0;
    }

    //Retourne le nombre de pièces sans paramétrage PA
    public ObtenirNombrePiecesParametragePAIntrouvable(): number {
        return this.resultatDerniereTransmission?.piecesParametragePAIntrouvable?.length ?? 0;
    }

    //Retourne le nombre de pièces en erreur
    public ObtenirNombrePiecesEnErreur(): number {
        return Object.keys(this.resultatDerniereTransmission?.piecesEnErreur ?? {}).length;
    }

    //Retourne, pour chaque pièce en erreur de transmission, sa référence et le message renvoyé par l'API
    public ObtenirDetailPiecesEnErreur(piecesEnErreur: Record<string, string> | null | undefined): { reference: string; message: string }[] {
        return Object.entries(piecesEnErreur ?? {}).map(([reference, message]) => ({ reference, message }));
    }

    //Retourne le nombre de pièces sans lisible
    public ObtenirNombrePiecesSansLisible(): number {
        return this.resultatDerniereTransmission?.piecesSansLisible?.length ?? 0;
    }

    //Formate la date de dernière transmission pour l'affichage
    public ObtenirTexteDateDerniereTransmission(): string | null {
        const dateDerniereTransmission = this.resultatDerniereTransmission?.dateDerniereTransmission;

        if (!dateDerniereTransmission) {
            return null;
        }

        const date = dateDerniereTransmission instanceof Date ? dateDerniereTransmission : new Date(dateDerniereTransmission);

        if (Number.isNaN(date.getTime())) {
            return null;
        }

        return this.FormaterDateHeure(date);
    }

    //Formate une date et son heure dans la langue active (ex. « 25/09/2026 à 14:30 » en français)
    private FormaterDateHeure(date: Date): string {
        const locale = this.translocoLocaleService.getLocale();
        const dateFormatee = date.toLocaleDateString(locale);
        const heureFormatee = date.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });

        return this.translocoService.translate('vente.recherche.date-heure', { date: dateFormatee, heure: heureFormatee });
    }

    //Compose le message d'erreur d'une opération à partir d'un message unique
    private TexteErreur(cleIntroduction: string, message: string): string {
        return this.translocoService.translate('vente.commun.message-erreur', { introduction: this.translocoService.translate(cleIntroduction), message: message });
    }

    //Compose le message d'erreur d'une opération à partir d'une liste de messages
    private TexteErreurs(cleIntroduction: string, messages: string[]): string {
        return this.translocoService.translate('vente.commun.message-erreurs', { introduction: this.translocoService.translate(cleIntroduction), messages: messages.join('\n') });
    }

    //Formate le temps écoulé depuis la mise à jour du résumé
    public ObtenirTexteTempEcoule(dateMiseAJour: Date | null): string | null {
        if (!dateMiseAJour) {
            return null;
        }

        const maintenant = new Date();
        const secondesEcoulees = Math.floor((maintenant.getTime() - dateMiseAJour.getTime()) / 1000);

        if (secondesEcoulees < 0) {
            return null;
        }

        const minutesEcoulees = Math.floor(secondesEcoulees / 60);
        const heuresEcoulees = Math.floor(minutesEcoulees / 60);

        if (heuresEcoulees > 0) {
            const minutesRestantes = minutesEcoulees % 60;
            if (minutesRestantes > 0) {
                return this.translocoService.translate('vente.recherche.temps-ecoule.heures-minutes', { heures: heuresEcoulees, minutes: minutesRestantes });
            } else {
                return this.translocoService.translate('vente.recherche.temps-ecoule.heures', { heures: heuresEcoulees });
            }
        } else {
            return this.translocoService.translate('vente.recherche.temps-ecoule.minutes', { minutes: minutesEcoulees });
        }
    }

    //Affiche le résumé de la dernière récupération
    public AfficherResumeRecuperation(resultat?: RecupererEtEnregistrerPiecesResultat | null): void {
        this.resultatDerniereRecuperation = resultat ?? new RecupererEtEnregistrerPiecesResultat();
        this.dateMiseAJourResumeRecuperation = new Date();
        this.afficherResumeRecuperation = true;

        if (this.intervalIdRecuperation) {
            clearInterval(this.intervalIdRecuperation);
        }
        this.intervalIdRecuperation = setInterval(() => {
            this.dateMiseAJourResumeRecuperation = this.dateMiseAJourResumeRecuperation;
        }, 60000);
    }

    //Masque le résumé de la dernière récupération
    public MasquerResumeRecuperation(): void {
        this.afficherResumeRecuperation = false;
        this.resultatDerniereRecuperation = null;
        this.dateMiseAJourResumeRecuperation = null;

        if (this.intervalIdRecuperation) {
            clearInterval(this.intervalIdRecuperation);
            this.intervalIdRecuperation = null;
        }
    }

    //Retourne le nombre de pièces récupérées
    public ObtenirNombrePiecesRecuperees(): number {
        return this.resultatDerniereRecuperation?.nombrePiecesRecuperees ?? 0;
    }

    //Retourne le nombre de pièces ajoutées
    public ObtenirNombrePiecesAjoutees(): number {
        return this.resultatDerniereRecuperation?.nombrePiecesAjoutees ?? 0;
    }

    //Retourne le nombre de pièces modifiées
    public ObtenirNombrePiecesModifiees(): number {
        return this.resultatDerniereRecuperation?.nombrePiecesModifiees ?? 0;
    }

    //Retourne le nombre de pièces en erreur lors de la récupération
    public ObtenirNombrePiecesEnErreurRecuperation(): number {
        return this.resultatDerniereRecuperation?.piecesEnErreur?.length ?? 0;
    }

    //Retourne le nombre de pièces modifiées dans le BO mais déjà transmises : leur modification n'est pas reprise
    public ObtenirNombrePiecesDejaTransmisesRecuperation(): number {
        return this.resultatDerniereRecuperation?.nombrePiecesDejaTransmises ?? 0;
    }

    //Affiche le résumé du dernier import d'encaissements
    public AfficherResumeImportEncaissements(resultat?: RecupererEtEnregistrerEncaissementsResultat | null): void {
        this.resultatDernierImportEncaissements = resultat ?? new RecupererEtEnregistrerEncaissementsResultat();
        this.dateMiseAJourResumeImportEncaissements = new Date();
        this.afficherResumeImportEncaissements = true;

        if (this.intervalIdImportEncaissements) {
            clearInterval(this.intervalIdImportEncaissements);
        }
        this.intervalIdImportEncaissements = setInterval(() => {
            this.dateMiseAJourResumeImportEncaissements = this.dateMiseAJourResumeImportEncaissements;
        }, 60000);
    }

    //Masque le résumé du dernier import d'encaissements
    public MasquerResumeImportEncaissements(): void {
        this.afficherResumeImportEncaissements = false;
        this.resultatDernierImportEncaissements = null;
        this.dateMiseAJourResumeImportEncaissements = null;

        if (this.intervalIdImportEncaissements) {
            clearInterval(this.intervalIdImportEncaissements);
            this.intervalIdImportEncaissements = null;
        }
    }

    //Retourne le nombre d'encaissements ajoutés
    public ObtenirNombreEncaissementsAjoutes(): number {
        return this.resultatDernierImportEncaissements?.nombreEncaissementsAjoutes ?? 0;
    }

    //Retourne le nombre d'encaissements en erreur
    public ObtenirNombreEncaissementsEnErreur(): number {
        return this.resultatDernierImportEncaissements?.nombreEncaissmentsEnErreur ?? 0;
    }

    //Affiche le résumé de la dernière transmission d'encaissements
    public AfficherResumeTransmissionEncaissements(resultat?: TransmettreEncaissementsResultat | null): void {
        this.resultatDerniereTransmissionEncaissements = resultat ?? new TransmettreEncaissementsResultat();
        this.dateMiseAJourResumeTransmissionEncaissements = new Date();
        this.afficherResumeTransmissionEncaissements = true;

        if (this.intervalIdTransmissionEncaissements) {
            clearInterval(this.intervalIdTransmissionEncaissements);
        }
        this.intervalIdTransmissionEncaissements = setInterval(() => {
            this.dateMiseAJourResumeTransmissionEncaissements = this.dateMiseAJourResumeTransmissionEncaissements;
        }, 60000);
    }

    //Masque le résumé de la dernière transmission d'encaissements
    public MasquerResumeTransmissionEncaissements(): void {
        this.afficherResumeTransmissionEncaissements = false;
        this.resultatDerniereTransmissionEncaissements = null;
        this.dateMiseAJourResumeTransmissionEncaissements = null;

        if (this.intervalIdTransmissionEncaissements) {
            clearInterval(this.intervalIdTransmissionEncaissements);
            this.intervalIdTransmissionEncaissements = null;
        }
    }

    //Retourne le nombre de pièces transmises avec succès (encaissements)
    public ObtenirNombrePiecesEncaissementsSucces(): number {
        return this.resultatDerniereTransmissionEncaissements?.piecesSucces?.length ?? 0;
    }

    //Retourne le nombre de pièces sans encaissements
    public ObtenirNombrePiecesSansEncaissements(): number {
        return this.resultatDerniereTransmissionEncaissements?.piecesSansEncaissements?.length ?? 0;
    }

    //Retourne le nombre de pièces pas encore transmises (encaissements)
    public ObtenirNombrePiecesPasEncoreTransmises(): number {
        return this.resultatDerniereTransmissionEncaissements?.piecesPasEncoreTransmises?.length ?? 0;
    }

    //Retourne le nombre de pièces sans paramétrage PA (encaissements)
    public ObtenirNombrePiecesEncaissementsParametragePAIntrouvable(): number {
        return this.resultatDerniereTransmissionEncaissements?.piecesParametragePAIntrouvable?.length ?? 0;
    }

    //Retourne le nombre de pièces en erreur (encaissements)
    public ObtenirNombrePiecesEncaissementsEnErreur(): number {
        return Object.keys(this.resultatDerniereTransmissionEncaissements?.piecesEnErreur ?? {}).length;
    }

    //Affiche le résumé de la dernière synchronisation des statuts
    public AfficherResumeSynchronisationStatuts(resultat?: SynchroniserStatutsPiecesResultat | null): void {
        this.resultatDerniereSynchronisationStatuts = resultat ?? new SynchroniserStatutsPiecesResultat();
        this.dateMiseAJourResumeSynchronisationStatuts = new Date();
        this.afficherResumeSynchronisationStatuts = true;

        if (this.intervalIdSynchronisationStatuts) {
            clearInterval(this.intervalIdSynchronisationStatuts);
        }
        this.intervalIdSynchronisationStatuts = setInterval(() => {
            this.dateMiseAJourResumeSynchronisationStatuts = this.dateMiseAJourResumeSynchronisationStatuts;
        }, 60000);
    }

    //Masque le résumé de la dernière synchronisation des statuts
    public MasquerResumeSynchronisationStatuts(): void {
        this.afficherResumeSynchronisationStatuts = false;
        this.resultatDerniereSynchronisationStatuts = null;
        this.dateMiseAJourResumeSynchronisationStatuts = null;

        if (this.intervalIdSynchronisationStatuts) {
            clearInterval(this.intervalIdSynchronisationStatuts);
            this.intervalIdSynchronisationStatuts = null;
        }
    }

    //Retourne le nombre de pièces synchronisées
    public ObtenirNombrePiecesSynchronisees(): number {
        return this.resultatDerniereSynchronisationStatuts?.piecesSynchronisees?.length ?? 0;
    }

    //Retourne le nombre de pièces avec statut introuvable
    public ObtenirNombrePiecesStatutIntrouvable(): number {
        return Object.keys(this.resultatDerniereSynchronisationStatuts?.piecesStatutIntrouvable ?? {}).length;
    }

    //Retourne le nombre de pièces en erreur lors de la synchronisation
    public ObtenirNombrePiecesEnErreurSynchronisation(): number {
        return this.resultatDerniereSynchronisationStatuts?.erreurs?.length ?? 0;
    }

    //Formate la date de fin de la dernière synchronisation des statuts pour l'affichage
    public ObtenirTexteDateDerniereSynchronisation(): string | null {
        const dateFinTraitement = this.resultatDerniereSynchronisationStatuts?.dateFinTraitement;

        if (!dateFinTraitement) {
            return null;
        }

        const date = dateFinTraitement instanceof Date ? dateFinTraitement : new Date(dateFinTraitement);

        if (Number.isNaN(date.getTime())) {
            return null;
        }

        return this.FormaterDateHeure(date);
    }

    // Permet de lancer le téléchargement d'un fichier EFact
    private TelechargerFileEFact(fichierEFact: FileEFact): void 
    {
        if (!fichierEFact)
            return;

        if (!fichierEFact.contenuBase64) {
            alert(this.translocoService.translate('vente.recherche.fichier-introuvable'));
            return;
        }

        const blob = this.Base64ToBlob(fichierEFact.contenuBase64, 'application/xml');
                    const url = window.URL.createObjectURL(blob);
                    const nomFichier = fichierEFact.nom?.toLowerCase().endsWith('.pdf') ? fichierEFact.nom : `${fichierEFact.nom ?? 'fichier'}.pdf`;
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = nomFichier;
                    link.click();
                    window.URL.revokeObjectURL(url);
    }

    private Base64ToBlob(base64: string, contentType: string): Blob {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    }
}
